// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"5943c02e","965":"954d5e93"}[chunkId] + ".chunk.css";
};